import { TenantUserSettings } from '@/api/generatedApi';
import { createContext } from 'react';

export type TenantsContextType = {
  setTenant: (tenant: TenantUserSettings, callback?: () => void) => Promise<void>;
  tenant?: TenantUserSettings;
  getPath: (path: string) => string;
  getTenantId: () => string;
  getTenantIdFromShortName: (shortName: string) => string | undefined;
};
export const TenantsContext = createContext<TenantsContextType | undefined>(undefined);
